export const onSportSelected=(sport)=>{
      return {
          type:'SPORT_SELECTED',
          sportSelected:sport
      }
} 